import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';

export const retrunMsgData = (doctorList) => {
  const msgData = {
    nameDoctor: `${ArabicToPersian(
      doctorList?.doctor?.nameDoctor
    )} ${
      doctorList?.doctor?.familyDoctor
        ? ArabicToPersian(doctorList?.doctor?.familyDoctor)
        : ''
    }`,
    serviceName: ArabicToPersian(
      doctorList?.dayInfo?.NameService
    ),
    dayName: ArabicToPersian(doctorList?.dayInfo?.dayName),
    dateNobat: doctorList?.dayInfo?.Text,
  };

  return msgData;
};
